import React from 'react';
import { styled } from 'dripsy';
import { View } from 'react-native';
import { useTranslation } from 'react-i18next';

import { BaseText } from '../../common/BaseText';

const WeekdaysContainer = styled(View)({
  flexDirection: 'row',
  alignItems: 'center',
});

const WeekdaysTextContainer = styled(View)({
  alignItems: 'center',
  justifyContent: 'center',
  size: 36,
});

const WeekdaysText = styled(BaseText)({
  color: '$text100',
  variant: 'text.small',
});

const WEEKDAYS_MAP_ARRAY = Array.from({ length: 7 });

export function CalendarWeekdays() {
  const { t } = useTranslation();

  return (
    <WeekdaysContainer>
      {WEEKDAYS_MAP_ARRAY.map((_, index) => (
        <WeekdaysTextContainer key={index}>
          <WeekdaysText>
            {t(`common.calendar.shortWeekdays.${index}`)}
          </WeekdaysText>
        </WeekdaysTextContainer>
      ))}
    </WeekdaysContainer>
  );
}
